import { jsx as _jsx } from "react/jsx-runtime";
import { createTheme } from "@mui/material/styles";
import { LinkBehavior } from "./LinkBehaviour";
import NoRowsOverlay from "app/components/NoRowsOverlay";
const backgroundColour = "#F8F8F8";
export const themeOptions = createTheme({
    components: {
        MuiLink: {
            defaultProps: {
                component: LinkBehavior,
            },
        },
        MuiButtonBase: {
            defaultProps: {
                LinkComponent: LinkBehavior,
            },
        },
        MuiDataGrid: {
            defaultProps: {
                slots: {
                    noRowsOverlay: () => (_jsx(NoRowsOverlay, { children: "There are no items available." })),
                },
                getRowHeight: () => "auto",
            },
            styleOverrides: {
                columnHeaders: {
                    border: "1px solid #f0f0f0",
                    backgroundColor: backgroundColour,
                },
                virtualScrollerContent: {
                    padding: "-2px",
                    border: "1px solid #d9d9d9",
                    borderTop: 0,
                },
                root: {
                    "& .MuiDataGrid-cell": {
                        padding: "14px 10px",
                    },
                },
            },
        },
        MuiTabs: {
            defaultProps: {
                variant: "scrollable",
            },
        },
    },
});
